import ComponentMapping from "@alboom/custom-page-components";

const getComponentManifest = (elementName, version = "V1") => {
  const target = ComponentMapping[elementName][version];
  const { manifest } = target;
  return manifest;
};

export default getComponentManifest;
